module.exports = __webpack_public_path__ + "static/media/manage.aa47e32f.svg";